export default __webpack_public_path__ + "static/logo_bv-f0643a1f4fd5c41805d9c30eaeb36827.png";